import {Label} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {defaultTo} from 'ramda';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

export type ReadOnlyFieldProps = {
  label: string;
  value: string | number | Nullish;
};

export function ReadOnlyField(props: ReadOnlyFieldProps) {
  return (
    <VStack>
      <Label>{props.label}</Label>
      <Text>{defaultTo(EMPTY_PLACEHOLDER, props.value)}</Text>
    </VStack>
  );
}
